import Vue from "vue";
import {
  ACTUAL_STATE_IMAGE_ADD,
  ACTUAL_STATE_IMAGE_DELETE,
  CHECK_ITEM_IMAGE_ADD,
  CHECK_ITEM_IMAGE_DELETE
} from "./mutation-types";
import { errorMessage } from "@/services/MessageService";
export default {
  /**
   * This mutation updates the actual state object of actual state images
   * @param {*} state creates a reference to the state of vuex to update a variable
   * @param {*} processedImage receives the processed image as an object
   */
  [ACTUAL_STATE_IMAGE_ADD](state, processedImage) {
    const { thumbnail, id } = processedImage;
    try {
      if (thumbnail) {
        Vue.set(state.itemsActualState, id, { thumbnail });
      }
    } catch (error) {
      errorMessage("Ha ocurrido un error inesperado al agregar la imagen.");
    }
  },
  [ACTUAL_STATE_IMAGE_DELETE](state, id) {
    Vue.set(state.itemsActualState, id);
  },
  /**
   * This mutation updates the check item object of check items
   * @param {*} state creates a reference to the state of vuex to update a variable
   * @param {*} processedImage receives the processed image as an object
   */
  [CHECK_ITEM_IMAGE_ADD](state, processedImage) {
    const { thumbnail, id } = processedImage;
    try {
      if (thumbnail) {
        Vue.set(state.itemsCheck, id, { thumbnail });
      }
    } catch (error) {
      errorMessage("Ha ocurrido un error inesperado al agregar la imagen.");
    }
  },
  [CHECK_ITEM_IMAGE_DELETE](state, id) {
    Vue.set(state.itemsCheck, id);
  }
};
